import { MenuItemsListFilterDto } from "services/menu/restModels";

// Размер страницы позиций. Совпадает с DEFAULT_PAGE_SIZE на бэке; больше 100 бэк не отдаст.
export const ITEMS_PAGE_SIZE = 40;

export const SEARCH_DEBOUNCE_MS = 300;

export const ITEMS_FILTERS: { value: MenuItemsListFilterDto; label: string }[] = [
    { value: "all", label: "Все" },
    { value: "stopList", label: "В стоп-листе" },
    { value: "noPhoto", label: "Без фото" },
];
